import { useQuery } from '@tanstack/react-query';

import { keysToCamel } from '@shared/helpers/snakeToCamel';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';
import { getEstimateInformation } from '@widgets/EstimateInformation/api/getEstimateInformation';
import { IEstimateInformation } from '@widgets/EstimateInformation/model/types/types';

export const getEstimateInformationQuery = () => {
    const {
        isLoading: isGetEstimateInformationLoading,
        isFetching,
        data,
        isSuccess,
        refetch,
        isPending,
    } = useQuery<IDataResponse<IEstimateInformation>, Error, IEstimateInformation>({
        queryKey: ['getEstimateInformation'],
        queryFn: getEstimateInformation,
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        select: (response: IDataResponse<IEstimateInformation>) => keysToCamel(response.data),
    });

    return { isGetEstimateInformationLoading, isFetching, isSuccess, data, refetch, isPending };
};
